import { render, staticRenderFns } from "./ArchivedDocumentList.vue?vue&type=template&id=30e3f764&scoped=true&"
import script from "./ArchivedDocumentList.vue?vue&type=script&lang=js&"
export * from "./ArchivedDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedDocumentList.vue?vue&type=style&index=0&id=30e3f764&prod&lang=scss&scoped=true&"
import style1 from "./ArchivedDocumentList.vue?vue&type=style&index=1&id=30e3f764&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e3f764",
  null
  
)

export default component.exports